import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../../utils/constants';
import './Explore.css';

const Explore = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  // Subcategorías para cada categoría principal (usando los IDs correctos de CATEGORIES)
  const subcategories = {
    'ciencia': [
      { id: 'tecnologia', name: 'Tecnología', icon: '💻', description: 'Innovación digital' },
      { id: 'medicina', name: 'Medicina', icon: '🏥', description: 'Salud y bienestar' },
      { id: 'fisica', name: 'Física', icon: '⚛️', description: 'Leyes del universo' },
      { id: 'biologia', name: 'Biología', icon: '🧬', description: 'Vida y organismos' },
      { id: 'astronomia', name: 'Astronomía', icon: '🔭', description: 'El cosmos' }
    ],
    'cultura': [
      { id: 'arte', name: 'Arte', icon: '🎨', description: 'Expresión creativa' },
      { id: 'literatura', name: 'Literatura', icon: '📚', description: 'Palabras escritas' },
      { id: 'musica', name: 'Música', icon: '🎵', description: 'Sonidos y ritmos' },
      { id: 'cine', name: 'Cine', icon: '🎬', description: 'Séptimo arte' },
      { id: 'teatro', name: 'Teatro', icon: '🎭', description: 'Artes escénicas' }
    ],
    'sociedad': [
      { id: 'politica', name: 'Política', icon: '🏛️', description: 'Gobierno y leyes' },
      { id: 'economia', name: 'Economía', icon: '📈', description: 'Mercados y finanzas' },
      { id: 'educacion', name: 'Educación', icon: '🎓', description: 'Aprendizaje' },
      { id: 'derechos', name: 'Derechos', icon: '⚖️', description: 'Justicia social' },
      { id: 'comunidad', name: 'Comunidad', icon: '🤝', description: 'Vida en sociedad' }
    ],
    'medio-ambiente': [
      { id: 'cambio-climatico', name: 'Cambio Climático', icon: '🌡️', description: 'Crisis ambiental' },
      { id: 'energias-renovables', name: 'Energías Renovables', icon: '⚡', description: 'Futuro verde' },
      { id: 'conservacion', name: 'Conservación', icon: '🦁', description: 'Protección animal' },
      { id: 'sostenibilidad', name: 'Sostenibilidad', icon: '♻️', description: 'Vida sostenible' },
      { id: 'naturaleza', name: 'Naturaleza', icon: '🌿', description: 'Flora y fauna' }
    ],
    'entretenimiento': [
      { id: 'gaming', name: 'Gaming', icon: '🎮', description: 'Videojuegos' },
      { id: 'deportes', name: 'Deportes', icon: '⚽', description: 'Competición' },
      { id: 'series', name: 'Series', icon: '📺', description: 'Streaming' },
      { id: 'memes', name: 'Memes', icon: '😂', description: 'Humor viral' },
      { id: 'viral', name: 'Viral', icon: '🔥', description: 'Tendencias' }
    ],
    'lifestyle': [
      { id: 'salud', name: 'Salud', icon: '❤️', description: 'Bienestar físico' },
      { id: 'fitness', name: 'Fitness', icon: '💪', description: 'Ejercicio' },
      { id: 'viajes', name: 'Viajes', icon: '✈️', description: 'Explorar el mundo' },
      { id: 'gastronomia', name: 'Gastronomía', icon: '🍳', description: 'Arte culinario' },
      { id: 'moda', name: 'Moda', icon: '👗', description: 'Estilo personal' }
    ]
  };

  // Estilos de categorías
  const categoryStyles = {
    'ciencia': { gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' },
    'cultura': { gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)' },
    'sociedad': { gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' },
    'medio-ambiente': { gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' },
    'entretenimiento': { gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)' },
    'lifestyle': { gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' }
  };

  return (
    <div className="explore-page">
      {/* Header de la página */}
      <div className="explore-header">
        <div className="explore-header-content">
          <h1>🌍 Explorar Conocimiento</h1>
          <p>Descubre todo el universo del saber organizado para ti</p>
        </div>
      </div>

      {/* Layout estilo Encarta */}
      <div className="explore-encarta-layout">
        {/* Columna izquierda - Categorías principales */}
        <aside className="explore-sidebar left">
          <div className="sidebar-title">Categorías</div>
          {CATEGORIES.slice(0, 3).map(category => (
            <button
              key={category.id}
              className={`category-card ${activeCategory === category.id ? 'active' : ''}`}
              style={{ '--card-gradient': categoryStyles[category.id]?.gradient }}
              onClick={() => setActiveCategory(activeCategory === category.id ? null : category.id)}
            >
              <span className="category-card-icon">{category.icon}</span>
              <span className="category-card-name">{category.name}</span>
            </button>
          ))}
        </aside>

        {/* Centro - Panel de contenido dinámico */}
        <main className="explore-main">
          <div className="explore-main-header">
            <div className="main-logo">
              <span className="logo-icon">🧠</span>
              <div className="logo-text">
                <span className="logo-title">GRAPHYRA</span>
                <span className="logo-subtitle">Explora</span>
              </div>
            </div>
          </div>

          {/* Subcategorías del centro */}
          <div className="subcategories-panel">
            {activeCategory ? (
              <>
                <h3 className="subcategories-title">
                  {CATEGORIES.find(c => c.id === activeCategory)?.icon} 
                  {' '}
                  {CATEGORIES.find(c => c.id === activeCategory)?.name}
                </h3>
                <div className="subcategories-list">
                  {subcategories[activeCategory]?.map(sub => (
                    <Link
                      key={sub.id}
                      to={`/category/${activeCategory}/${sub.id}`}
                      className="subcategory-item"
                    >
                      <span className="subcategory-icon">{sub.icon}</span>
                      <div className="subcategory-info">
                        <span className="subcategory-name">{sub.name}</span>
                        <span className="subcategory-desc">{sub.description}</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </>
            ) : (
              <div className="explore-welcome">
                <div className="welcome-grid">
                  <Link to="/games" className="welcome-card games">
                    <span className="welcome-icon">🎮</span>
                    <span className="welcome-label">Juegos Educativos</span>
                  </Link>
                  <Link to="/tv" className="welcome-card tv">
                    <span className="welcome-icon">📺</span>
                    <span className="welcome-label">Graphyra TV</span>
                  </Link>
                  <Link to="/magazine" className="welcome-card magazine">
                    <span className="welcome-icon">📰</span>
                    <span className="welcome-label">Magazine Semanal</span>
                  </Link>
                  <Link to="/library" className="welcome-card library">
                    <span className="welcome-icon">📚</span>
                    <span className="welcome-label">Biblioteca</span>
                  </Link>
                </div>
                <p className="welcome-hint">
                  � Haz clic en una categoría para ver sus subcategorías
                </p>
              </div>
            )}
          </div>
        </main>

        {/* Columna derecha - Más categorías */}
        <aside className="explore-sidebar right">
          <div className="sidebar-title">Más temas</div>
          {CATEGORIES.slice(3, 6).map(category => (
            <button
              key={category.id}
              className={`category-card ${activeCategory === category.id ? 'active' : ''}`}
              style={{ '--card-gradient': categoryStyles[category.id]?.gradient }}
              onClick={() => setActiveCategory(activeCategory === category.id ? null : category.id)}
            >
              <span className="category-card-icon">{category.icon}</span>
              <span className="category-card-name">{category.name}</span>
            </button>
          ))}
        </aside>
      </div>

      {/* Grid de todas las categorías para móvil y vista alternativa */}
      <section className="explore-all-categories">
        <h2>Todas las Categorías</h2>
        <div className="categories-grid">
          {CATEGORIES.map(category => (
            <div key={category.id} className="category-full-card" style={{ '--cat-color': category.color }}>
              <Link to={`/category/${category.id}`} className="category-full-header">
                <span className="cat-icon">{category.icon}</span>
                <h3>{category.name}</h3>
              </Link>
              <ul className="category-full-subs">
                {subcategories[category.id]?.slice(0, 4).map(sub => (
                  <li key={sub.id}>
                    <Link to={`/category/${category.id}/${sub.id}`}>
                      {sub.icon} {sub.name}
                    </Link>
                  </li>
                ))}
                <li className="see-more">
                  <Link to={`/category/${category.id}`}>Ver todo →</Link>
                </li>
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Explore;
